var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTennis = function SvgTennis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.049 11.055a9.003 9.003 0 018.005-8.004 10.997 10.997 0 009.895 9.895 9.001 9.001 0 01-8.004 8.004 10.997 10.997 0 00-9.896-9.895zm7.882 9.876a8.996 8.996 0 01-7.863-7.863 8.995 8.995 0 017.863 7.863zm2.136-17.862a8.997 8.997 0 017.863 7.864 8.997 8.997 0 01-7.863-7.864zM1 12c0 6.075 4.924 11 11 11 6.075 0 11-4.925 11-11S18.075 1 12 1C5.924 1 1 5.925 1 12z"
  })));
};
export default SvgTennis;